var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.502 9.00012H7.50195C7.10413 9.00012 6.7226 9.15816 6.44129 9.43946C6.15999 9.72077 6.00195 10.1023 6.00195 10.5001C6.00195 10.8979 6.15999 11.2795 6.44129 11.5608C6.7226 11.8421 7.10413 12.0001 7.50195 12.0001H9.00195V39.0001C9.00195 39.7958 9.31802 40.5588 9.88063 41.1214C10.4432 41.6841 11.2063 42.0001 12.002 42.0001H36.002C36.7976 42.0001 37.5607 41.6841 38.1233 41.1214C38.6859 40.5588 39.002 39.7958 39.002 39.0001V12.0001H40.502C40.8998 12.0001 41.2813 11.8421 41.5626 11.5608C41.8439 11.2795 42.002 10.8979 42.002 10.5001C42.002 10.1023 41.8439 9.72077 41.5626 9.43946C41.2813 9.15816 40.8998 9.00012 40.502 9.00012ZM36.002 39.0001H12.002V12.0001H36.002V39.0001ZM15.002 4.50012C15.002 4.1023 15.16 3.72077 15.4413 3.43946C15.7226 3.15816 16.1041 3.00012 16.502 3.00012H31.502C31.8998 3.00012 32.2813 3.15816 32.5626 3.43946C32.8439 3.72077 33.002 4.1023 33.002 4.50012C33.002 4.89795 32.8439 5.27948 32.5626 5.56078C32.2813 5.84209 31.8998 6.00012 31.502 6.00012H16.502C16.1041 6.00012 15.7226 5.84209 15.4413 5.56078C15.16 5.27948 15.002 4.89795 15.002 4.50012Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.8d74d930e6231a62ca55c8ee74543636.svg";
export { ForwardRef as ReactComponent };